import { createAction, props } from '@ngrx/store';
import { LabReqEntity } from './lab-req.models';

export const loadLabReq = createAction(
  '[LabReq] Load LabReq',
  props<{ _id: string }>()
);

export const loadLabReqSuccess = createAction(
  '[LabReq] Load LabReq Success',
  props<{ labReq: LabReqEntity }>()
);

export const loadLabReqFailure = createAction(
  '[LabReq] Load LabReq Failure',
  props<{ error: any }>()
);

export const loadPatientLabReqs = createAction(
  '[LabReq] Load LabReqs',
  props<{ filters?: any }>()
);

export const loadPatientLabReqsSuccess = createAction(
  '[LabReq] Load LabReqs Success',
  props<{ labReqs: LabReqEntity[] }>()
);

export const loadPatientLabReqsFailure = createAction(
  '[LabReq] Load LabReqs Failure',
  props<{ error: any }>()
);

export const loadLatestLabReq = createAction('[LabReq] Load Latest LabReq');
